// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// Code generated by Microsoft (R) AutoRest Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is regenerated.

import type { PagedAsyncIterableIterator } from "@azure/core-paging";
import type {
  WorkflowRunAction,
  WorkflowRunActionsListOptionalParams,
  ExpressionRoot,
  WorkflowRunActionsListExpressionTracesOptionalParams,
  WorkflowRunActionsGetOptionalParams,
  WorkflowRunActionsGetResponse,
} from "../models/index.js";

/// <reference lib="esnext.asynciterable" />
/** Interface representing a WorkflowRunActions. */
export interface WorkflowRunActions {
  /**
   * Gets a list of workflow run actions.
   * @param resourceGroupName Name of the resource group to which the resource belongs.
   * @param name Site name.
   * @param workflowName The workflow name.
   * @param runName The workflow run name.
   * @param options The options parameters.
   */
  list(
    resourceGroupName: string,
    name: string,
    workflowName: string,
    runName: string,
    options?: WorkflowRunActionsListOptionalParams,
  ): PagedAsyncIterableIterator<WorkflowRunAction>;
  /**
   * Lists a workflow run expression trace.
   * @param resourceGroupName Name of the resource group to which the resource belongs.
   * @param name Site name.
   * @param workflowName The workflow name.
   * @param runName The workflow run name.
   * @param actionName The workflow action name.
   * @param options The options parameters.
   */
  listExpressionTraces(
    resourceGroupName: string,
    name: string,
    workflowName: string,
    runName: string,
    actionName: string,
    options?: WorkflowRunActionsListExpressionTracesOptionalParams,
  ): PagedAsyncIterableIterator<ExpressionRoot>;
  /**
   * Gets a workflow run action.
   * @param resourceGroupName Name of the resource group to which the resource belongs.
   * @param name Site name.
   * @param workflowName The workflow name.
   * @param runName The workflow run name.
   * @param actionName The workflow action name.
   * @param options The options parameters.
   */
  get(
    resourceGroupName: string,
    name: string,
    workflowName: string,
    runName: string,
    actionName: string,
    options?: WorkflowRunActionsGetOptionalParams,
  ): Promise<WorkflowRunActionsGetResponse>;
}
